import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

const langKey = (lang: string): 'pt' | 'de' | 'en' => {
  if (lang === 'de') return 'de';
  if (lang === 'en') return 'en';
  return 'pt';
};

export default function ArticlesSection() {
  const { t, i18n } = useTranslation();
  const lk = langKey(i18n.language);
  const prefix = i18n.language === 'pt' ? '' : '/' + i18n.language;

  return (
    <section className="section-padding bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            {t('pillars.title')}
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            {t('pillars.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {articles.map((article) => (
            <a
              key={article.slug}
              href={prefix + '/article/' + article.slug}
              className="group card p-5 md:p-6 hover:shadow-md transition-all duration-200 flex flex-col"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mb-4">
                <i className={`${article.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                {article.title[lk]}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                {article.excerpt[lk]}
              </p>
              <span className="inline-flex items-center text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                {t('pillars.readMore')}
                <i className="ri-arrow-right-line ml-1.5 group-hover:translate-x-1 transition-transform"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}